export default "__VITE_ASSET__DSMuB3nW__"